"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const common_1 = require("../../common");
const schema = {
    type: "object",
    properties: {
        visitDate: {
            type: "number",
            format: "date",
            title: "Visit Date",
            disableFuture: true,
        },
        clinicianAppointment: (0, common_1.makeAppointmentSchema)({
            disablePast: true,
        }),
        notes: { type: "string", title: "Notes", maxLength: 3000 },
    },
    required: ["visitDate"],
};
exports.default = schema;
